import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=5bd18781&scoped=true"
import script from "./Deals.vue?vue&type=script&lang=js"
export * from "./Deals.vue?vue&type=script&lang=js"
import style0 from "./Deals.vue?vue&type=style&index=0&id=5bd18781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd18781",
  null
  
)

export default component.exports